import Backdrop from "../../components/global/Backdrop";
import Spacer from "../../components/global/Spacer";
import styled from "styled-components";
import sadEmojiGroup from "assets/images/sadEmojiGroup.svg";
import Button from "components/global/Button";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { setLoggedIn } from "api";
import { connect } from "react-redux";

const Wrapper = styled(Backdrop)`
  background-color: rgba(7, 7, 12, 0.5);
  backdrop-filter: blur(5px);

  .card {
    width: 480px;
    padding: 48px;
    background-color: var(--white);
    border-radius: 16px;

    .title {
      font-weight: 700;
      font-size: 24px;
    }

    .description {
      font-size: 16px;
      font-style: normal;
      font-weight: 450;
      line-height: 24px;
    }

    ol {
      padding: 0 24px;
    }

    li {
      padding-bottom: 12px;
      font-size: 16px;
      font-style: normal;
      font-weight: 450;
      line-height: 24px;
    }

    .logout {
      padding-top: 24px;
      color: #fd0403;
    }
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 24px);
      padding: 24px;

      .title {
        font-weight: 700;
        font-size: 18px;
      }

      .description {
        font-size: 14px;
        line-height: 18px;
      }

      li {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
`;

const PaymentFailureModal = ({ current_sub }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (
      pathname !== "/dashboard/plans" &&
      current_sub?.status === 0
    ) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [pathname, current_sub]);

  return (
    <Wrapper
      id="upgradeFailureModal"
      className={`upgradeFailureModal flexRow alignCenter justifyCenter ${
        showModal && "show"
      }`}
    >
      <div className="card flexColumn alignCenter">
        <img src={sadEmojiGroup} alt="emoji" height="36px" />
        <Spacer y={2.4} />
        <h5>Subscription Expired</h5>
        <Spacer y={1.2} />
        <p className="description">
          Apologies, but your account subscription has expired. To
          continue using our services:
        </p>
        <Spacer y={2.4} />
        <ol>
          <li>
            Visit the plans page to <b>Renew, Upgrade,</b> or <b>Downgrade</b>{" "}
            your payment plan.
          </li>
          <li>
            Ensure a seamless experience by <b>Updating</b> your payment
            information for future transactions.
          </li>
        </ol>
        <Spacer y={2.4} />
        <Button
          text={"Go to Plans page"}
          fullWidth
          bg="var(--secondary)"
          onClick={() => {
            setShowModal(false);
            history.push("/dashboard/plans");
          }}
        />
        <button className="logout" onClick={() => setLoggedIn(false)}>
          Logout
        </button>
      </div>
    </Wrapper>
  );
};
const mapStateToProps = (state) => {
  return {
    current_sub: state.current_sub,
  };
};

export default connect(mapStateToProps)(PaymentFailureModal);
